import React, { useState, useEffect } from 'react';
import { Dimmer } from 'semantic-ui-react';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { withRouter, useLocation, Link } from 'react-router-dom';
import { efesGray } from '../../theme';
import {
  recoverRecurringPayment,
} from '../../redux/modules/payment';
import ScrollToTopPage from '../ScrollToTopPage';
import Spinner from '../Loaders/Spinner';
import MainButton from '../MUI/MainButton';
import EfesContentHeader from '../EfesContentHeader';
import ErrorContent from './PageContent/ErrorContent';
import AttachedCard from './PageContent/AttachedCard/AttachedCard';
import useDeviceResize from '../../hooks/useDeviceResize';
import { errorTexts, PAYMENT_FAILED_ERROR_CODE } from './options';

import styles from './PaymentConfirmation.module.scss';
import useStyles from './makeStyles';
import { getAttachedCard } from '../../redux/modules/contractSubsription';

import successContract from '../../styles/svgs/succesContract.svg';
import warningContract from '../../styles/svgs/warningContract.svg';
import attachCard from '../../img/svgs/payment/attachCard.svg';

const AttachCardToPolicyConfirmation = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const location = useLocation();
  const classes = useStyles();

  const spinnerSize = useDeviceResize('lg') ? 80 : 50;

  const {
    recoveringRecurringPayment,
    gettingPaymentUrl,
    payingInProgress,
  } = useSelector((state) => state.paymentReducer, shallowEqual);

  const { attachedCard, loadingAttachedCard } = useSelector((state) => state.contractSubscription, shallowEqual);
  const [success, setSuccess] = useState(false);
  const [paymentError, setPaymentError] = useState(false);

  useEffect(() => {
    const urlParams = queryString.parse(location.search);
    const urlSuccess = urlParams.success;
    const urlError = urlParams.error;
    const urlBindingId = urlParams.bindingId;

    if (!urlSuccess || urlSuccess === '0') {
      setSuccess(false);
      if (urlError === PAYMENT_FAILED_ERROR_CODE) {
        setPaymentError(true);
        dispatch(recoverRecurringPayment(urlParams.id, urlParams.type));
      }
    } else if (urlSuccess === '1') {
      setSuccess(true);
      dispatch(getAttachedCard(urlBindingId));
    }
  }, [dispatch, location.search]);

  let content;

  if (!success) {
    const urlParams = queryString.parse(location.search);
    const errorCode = urlParams.error;
    const error = errorTexts[errorCode] ? errorTexts[errorCode] : errorTexts.default;
    const errorTitle = t(error.title);
    const errorDescription = t(error.description);

    const isLoading = gettingPaymentUrl || payingInProgress;

    content = (
      <ErrorContent
        isLoading={isLoading}
        paymentError={paymentError}
        errorDescription={errorDescription}
        errorTitle={errorTitle}
        errorCode={errorCode}
      />
    );
  } else {
    content = (
      <div id={styles.confirmationScreen}>
        <div className={styles.paymentStatusBlock}>
          <img className={styles.icon} src={success && attachedCard ? successContract : warningContract} alt="" />
          <div>
            {
              success
                && <div className={classes.statusTitle}>{t('paymentConfirmation.attachCardSuccessText')}</div>

            }
            {(attachedCard && !loadingAttachedCard) && (
            <AttachedCard attachedCard={attachedCard} />
            )}
            {(!attachedCard && !loadingAttachedCard) && (
              <div className={classes.loadingText}>
                <p>{t('paymentConfirmation.cardNotFound')}</p>
              </div>
            )}
            {!attachedCard && loadingAttachedCard && (
              <div className={classes.loadingText}>
                <div>
                  <Spinner color={efesGray} width={spinnerSize} height={spinnerSize} />
                </div>
                <p>{t('paymentConfirmation.attachCardRemainingText')}</p>
              </div>
            )}
            <Link to="/">
              <MainButton variant="contained" color="primary" className={classes.startNewButton}>
                {t('paymentConfirmation.finish')}
              </MainButton>
            </Link>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div>
      <ScrollToTopPage />
      {recoveringRecurringPayment && (
        <Dimmer active inverted>
          <div>
            <Spinner />
          </div>
        </Dimmer>
      )}
      <EfesContentHeader
        headerText="automaticRecurringPayment.headerTitle"
        headerImage={attachCard}
      />
      <div className={styles.container}>
        <div className={styles.content}>{content}</div>
      </div>
    </div>
  );
};

export default withRouter(AttachCardToPolicyConfirmation);
